import React, { useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

import { QUERIES } from '../constants/mediaQueries';
import { HEADER_CTA_LINK, HEADER_NAV_LINKS } from '../constants/navigationLinks';
import { useScrollLock } from '../hooks/useScrollLock';
import BurgerButton from './BurgerButton';
import Links from './Links';
import Button from './Button';
import Logo from './Logo';

const NavSection = styled.section`
  position: relative;
  width: 100%;
  border-bottom: var(--border-default);
  background-color: var(--color-neutral-white);
  padding: 0;
  justify-content: end;

  ul {
    align-items: end;
  }

  ${QUERIES.minLaptop} {
    display: none;
  }
`;

const NavWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--spacing-large);
  gap: var(--spacing-base);
`;

const LogoWrapper = styled.div`
  flex-shrink: 0;
`;

const TopControls = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-base);
`;

const CtaButtonMobile = styled(Button)`
  padding: var(--button-padding-v) var(--spacing-large);
  font-size: var(--body-small-size);
`;

const MobileMenuPanel = styled(motion.div)<{ $isOpen: boolean }>`
  position: fixed;
  right: 0;
  width: 100%;
  background-color: var(--color-neutral-white);
  overflow-y: auto;
  visibility: ${({ $isOpen }: { $isOpen: boolean }) => ($isOpen ? 'visible' : 'hidden')};
  z-index: 9;
  border-top: var(--border-default);
  padding: var(--spacing-xlarge) var(--spacing-large);
`;

const MobileNav: React.FC = () => {
  const menuPanelId = 'mobile-nav-panel';
  const [open, setOpen] = useState(false);
  useScrollLock(open);
  const handleClose = () => setOpen(false);

  return (
    <NavSection>
      <NavWrapper>
        <LogoWrapper>
          <Logo />
        </LogoWrapper>
        <TopControls>
          <CtaButtonMobile
            variant="cta"
            href={HEADER_CTA_LINK.to}
            ariaLabel={HEADER_CTA_LINK.ariaLabel}
          >
            {HEADER_CTA_LINK.label}
          </CtaButtonMobile>
          <BurgerButton open={open} setOpen={setOpen} controlsId={menuPanelId} />
        </TopControls>
      </NavWrapper>

      <MobileMenuPanel
        id={menuPanelId}
        aria-hidden={!open}
        $isOpen={open}
        animate={{
          height: open ? '100%' : 0,
          opacity: open ? 1 : 0,
        }}
        initial={{ height: 0, opacity: 0 }}
        exit={{ height: 0, opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        {open && (
          <Links links={HEADER_NAV_LINKS} gap="large" vertical={true} onClick={handleClose} />
        )}
      </MobileMenuPanel>
    </NavSection>
  );
};

export default MobileNav;
